import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/user-1.jpg'
import _imports_1 from '@/assets/images/user-2.jpg'
import _imports_2 from '@/assets/images/user-3.jpg'
import _imports_3 from '@/assets/images/user-4.jpg'
import _imports_4 from '@/assets/images/user-5.jpg'
import _imports_5 from '@/assets/images/user-103.png'
import _imports_6 from '@/assets/images/user-104.png'
import _imports_7 from '@/assets/images/user-105.png'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4 pt-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "default-table-area style-two real-estate-customers" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[64] || (_cache[64] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1" }, "Customer ID")
                  ])
                ]),
                _createElementVNode("th", { scope: "col" }, "Customer Name"),
                _createElementVNode("th", { scope: "col" }, "Location"),
                _createElementVNode("th", { scope: "col" }, "Join Date"),
                _createElementVNode("th", { scope: "col" }, "Phone Number"),
                _createElementVNode("th", { scope: "col" }, "Email Address"),
                _createElementVNode("th", { scope: "col" }, "Customer Type"),
                _createElementVNode("th", { scope: "col" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[1] || (_cache[1] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault2"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1 text-secondary" }, "#TRE0015")
                  ])
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        class: "wh-44 rounded-2",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Sarah Johnson")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("td", null, "74 Grim Avenue San Diego,", -1)),
                _cache[3] || (_cache[3] = _createElementVNode("td", null, "2024-10-01", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("td", null, "(123) 456-7890", -1)),
                _cache[5] || (_cache[5] = _createElementVNode("td", { class: "text-primary" }, "sarah@email.com", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("td", null, "Buyer", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " visibility ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, " edit ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, " delete ")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[9] || (_cache[9] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault2"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1 text-secondary" }, "#TRE0099")
                  ])
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createElementVNode("img", {
                        src: _imports_1,
                        class: "wh-44 rounded-2",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Michael Smith")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("td", null, "9 Paul Wayne Haggerty Road", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("td", null, "2024-09-28", -1)),
                _cache[12] || (_cache[12] = _createElementVNode("td", null, "(987) 654-3210", -1)),
                _cache[13] || (_cache[13] = _createElementVNode("td", { class: "text-primary" }, "smith@email.com", -1)),
                _cache[14] || (_cache[14] = _createElementVNode("td", null, "Seller", -1)),
                _cache[15] || (_cache[15] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " visibility ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, " edit ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, " delete ")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[17] || (_cache[17] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault2"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1 text-secondary" }, "#TRE0145")
                  ])
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "wh-44 rounded-2",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Emily Brown")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[18] || (_cache[18] = _createElementVNode("td", null, "61 Ottis Street Oklahoma City", -1)),
                _cache[19] || (_cache[19] = _createElementVNode("td", null, "2024-09-25", -1)),
                _cache[20] || (_cache[20] = _createElementVNode("td", null, "(555) 258-1598", -1)),
                _cache[21] || (_cache[21] = _createElementVNode("td", { class: "text-primary" }, "brown@email.com", -1)),
                _cache[22] || (_cache[22] = _createElementVNode("td", null, "Commercial", -1)),
                _cache[23] || (_cache[23] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " visibility ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, " edit ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, " delete ")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[25] || (_cache[25] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault2"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1 text-secondary" }, "#TRE0247")
                  ])
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                      _createElementVNode("img", {
                        src: _imports_3,
                        class: "wh-44 rounded-2",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Jason Lee")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[26] || (_cache[26] = _createElementVNode("td", null, "Residential", -1)),
                _cache[27] || (_cache[27] = _createElementVNode("td", null, "2024-09-22", -1)),
                _cache[28] || (_cache[28] = _createElementVNode("td", null, "(444) 789-0123", -1)),
                _cache[29] || (_cache[29] = _createElementVNode("td", { class: "text-primary" }, "lee@email.com", -1)),
                _cache[30] || (_cache[30] = _createElementVNode("td", null, "Investor", -1)),
                _cache[31] || (_cache[31] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " visibility ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, " edit ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, " delete ")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[33] || (_cache[33] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault2"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1 text-secondary" }, "#TRE0299")
                  ])
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[32] || (_cache[32] = [
                      _createElementVNode("img", {
                        src: _imports_4,
                        class: "wh-44 rounded-2",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Ashley Davis")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[34] || (_cache[34] = _createElementVNode("td", null, "01 Lakeland Terrace Detroit", -1)),
                _cache[35] || (_cache[35] = _createElementVNode("td", null, "2024-09-20", -1)),
                _cache[36] || (_cache[36] = _createElementVNode("td", null, "(333) 456-3333", -1)),
                _cache[37] || (_cache[37] = _createElementVNode("td", { class: "text-primary" }, "davis@email.com", -1)),
                _cache[38] || (_cache[38] = _createElementVNode("td", null, "Industrial", -1)),
                _cache[39] || (_cache[39] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " visibility ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, " edit ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, " delete ")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[41] || (_cache[41] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault2"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1 text-secondary" }, "#TRE0311")
                  ])
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[40] || (_cache[40] = [
                      _createElementVNode("img", {
                        src: _imports_5,
                        class: "wh-44 rounded-2",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Shirley Cooper")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[42] || (_cache[42] = _createElementVNode("td", null, "29 Aviation Way Los Angeles", -1)),
                _cache[43] || (_cache[43] = _createElementVNode("td", null, "2024-09-23", -1)),
                _cache[44] || (_cache[44] = _createElementVNode("td", null, "(111) 775-8890", -1)),
                _cache[45] || (_cache[45] = _createElementVNode("td", { class: "text-primary" }, "cooper@email.com", -1)),
                _cache[46] || (_cache[46] = _createElementVNode("td", null, "Buyer", -1)),
                _cache[47] || (_cache[47] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " visibility ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, " edit ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, " delete ")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[49] || (_cache[49] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault2"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1 text-secondary" }, "#TRE0328")
                  ])
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[48] || (_cache[48] = [
                      _createElementVNode("img", {
                        src: _imports_6,
                        class: "wh-44 rounded-2",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Bret Brown")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[50] || (_cache[50] = _createElementVNode("td", null, "2 Little Acres Lane Mattoon", -1)),
                _cache[51] || (_cache[51] = _createElementVNode("td", null, "2024-09-27", -1)),
                _cache[52] || (_cache[52] = _createElementVNode("td", null, "(555) 222-3365", -1)),
                _cache[53] || (_cache[53] = _createElementVNode("td", { class: "text-primary" }, "bret@email.com", -1)),
                _cache[54] || (_cache[54] = _createElementVNode("td", null, "Seller", -1)),
                _cache[55] || (_cache[55] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " visibility ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, " edit ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, " delete ")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[57] || (_cache[57] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault2"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1 text-secondary" }, "#TRE0333")
                  ])
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[56] || (_cache[56] = [
                      _createElementVNode("img", {
                        src: _imports_7,
                        class: "wh-44 rounded-2",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Frances Mills")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[58] || (_cache[58] = _createElementVNode("td", null, "47 Hope Street Portland", -1)),
                _cache[59] || (_cache[59] = _createElementVNode("td", null, "2024-09-28", -1)),
                _cache[60] || (_cache[60] = _createElementVNode("td", null, "(222) 722-8750", -1)),
                _cache[61] || (_cache[61] = _createElementVNode("td", { class: "text-primary" }, "mills@email.com", -1)),
                _cache[62] || (_cache[62] = _createElementVNode("td", null, "Commercial", -1)),
                _cache[63] || (_cache[63] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " visibility ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, " edit ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, " delete ")
                    ])
                  ])
                ], -1))
              ])
            ])
          ])
        ]),
        _createVNode(_component_Pagination, {
          total: "30",
          items: "08",
          class: "p-4"
        })
      ])
    ])
  ]))
}